import { handleResponse } from "../util/functions";
import { getToken } from "../helpers/helperJWT";
import { loaderService } from "./loaderService";

const { GlobalConstants } = require("src/data/GlobalConstants");

const url = GlobalConstants.urlApi;

export const mercadoServices = {
    getCategorias,
    getMercados,
    getProductoMercado,
    getClienteMercado,
    getColumnsCategorias,
    getOrganizacion,
    getProductos,
    validateExcelClienteMercado,
    saveExcelClienteMercado,
    setCategoria,
    setMercado,
    setMercadoExcel,
    getSelectMercados,
    setClienteMercados,
    getProductsByMercado,
    updateProductoMercado,
    setProductosMercado,
    setProductoMercadoExcel
}

function getCategorias() {
    loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify()
    }

    return fetch(`${url}/mercados/getCategorias`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getMercados(data) {
    loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    }

    return fetch(`${url}/mercados/getMercados`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getClienteMercado(data) {
    loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    }

    return fetch(`${url}/mercados/getClienteMercado`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getProductoMercado(data) {
    loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    }

    return fetch(`${url}/mercados/getProductoMercado`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getColumnsCategorias() {
    loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify()
    }

    return fetch(`${url}/mercados/getColumnsCategorias`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getOrganizacion(){
    loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify()
    }

    return fetch(`${url}/mercados/getOrganizacion`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getProductos(){
    loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify()
    }

    return fetch(`${url}/mercados/getProductos`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function validateExcelClienteMercado(data) {
    loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    }

    return fetch(`${url}/mercados/validate/excelClienteMercado`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function saveExcelClienteMercado(data, file) {
    loaderService.showLoader({label: "Cargando..."});

    const formData = new FormData();

    formData.append('data', JSON.stringify(data));
    formData.append('app', 'maestros');
    formData.append('interface', 'ClienteMercados');
    formData.append('EXCEL', file);

    const requestOptions = {
        method: 'POST',
        headers: {
            'Authorization': getToken()
        },
        body: formData
    }

    return fetch(`${url}/mercados/save/excelClienteMercado`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function setCategoria(data){
    loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    }

    return fetch(`${url}/mercados/setCategoria`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function setMercado(data){
    loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    }

    return fetch(`${url}/mercados/setMercado`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function setMercadoExcel({data, file}){
    loaderService.showLoader({label: "Cargando..."});
    const formData = new FormData();

    formData.append('data', JSON.stringify(data));
    formData.append('app', 'maestros');
    formData.append('interface', 'mercados');
    formData.append('EXCEL', file);

    const requestOptions = {
        method: 'POST',
        headers: {
            'Authorization': getToken()
        },
        body: formData
    }

    return fetch(`${url}/mercados/setMercadoExcel`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getSelectMercados(){
    loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: ''
    }

    return fetch(`${url}/mercados/getSelectMercado`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function setClienteMercados(data){
    loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    }

    return fetch(`${url}/mercados/setClienteMercado`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getProductsByMercado(data){
    loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    }

    return fetch(`${url}/mercados/getProductsByMercado`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function updateProductoMercado(data){
    loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify({data: data})
    }

    return fetch(`${url}/mercados/updateProductoMercado`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function setProductosMercado(data){
    loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify({data})
    }

    return fetch(`${url}/mercados/setProductoMercado`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function setProductoMercadoExcel(data, file){
    loaderService.showLoader({label: "Cargando..."});
    const formData = new FormData();

    formData.append('data', JSON.stringify(data));
    formData.append('app', 'maestros');
    formData.append('interface', 'ProductoMercado');
    formData.append('EXCEL', file);

    const requestOptions = {
        method: 'POST',
        headers: {
            'Authorization': getToken()
        },
        body: formData
    }

    return fetch(`${url}/mercados/setProductoMercadoExcel`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}
